export default __webpack_public_path__ + "static/media/Slide-2.2f1ec498.jpg";